var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-100 loadingTask"},[_c('div',{staticClass:"snippet",attrs:{"data-title":".dot-windmill"}},[_c('span',[_vm._v(_vm._s(_vm.$t('common.' + _vm.text)))]),_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stage"},[_c('div',{staticClass:"dot-windmill"})])
}]

export { render, staticRenderFns }